import React from 'react';
import {Button, Card, CardContent, Grid, Snackbar, Typography} from '@mui/material';
import {useTranslation} from 'react-i18next';

import routes from '../../../common/constants/routes'
import {useCartContext} from '../../../context/CartContext';
import CCOLink from '../../fundamentals/CCOLink'
import {usePageContext} from "../../../context/PageContext";
import {ADDITIONAL_OFFSET_LARGE_SCREEN, INITIAL_OFFSET_CART} from "../../fundamentals/CCOCartFab";
import CCOPicture from "../../fundamentals/CCOPicture";
import {toCommaSeparatedDecimal} from "../../../utility/componentUtil";
import {getRouteUrl} from "../../../utility/navigationUtil";

interface Props {
    open?: boolean;
    item?: any;
}

function C056QueryListCartNotification(props: Props) {
    const pageContext = usePageContext();
    const cartLink = getRouteUrl(pageContext.rootUrl, routes.PUBLICATIONS.CART)
    const {t} = useTranslation();
    const cartContext = useCartContext();
    const isStorybook = typeof window !== "undefined" && (window as any).__STORYBOOK_CLIENT_API__;
    const cartUrl = getRouteUrl(pageContext.rootUrl, routes.PUBLICATIONS.CART)

    const currentItem = isStorybook ? null :cartContext.getLatestAddedItem();

    return (
        <CCOLink tabIndex={-1} target={cartUrl}>
            <Snackbar
                anchorOrigin={{horizontal: 'right', vertical: 'top'}}
                autoHideDuration={3}
                open={props.open}
                sx={cartNotificationSnackbarStyle}
            >
                <Card>
                    <CardContent>
                        <Typography textAlign={'center'} fontWeight={'bold'}>
                            {t("cart.added_to_cart_message")}:
                        </Typography>
                        <Grid container spacing={2} margin={2}>
                            <Grid item xs={4}>
                                <CCOPicture
                                    sxImage={{width: 100}}
                                    name={currentItem?.sosPublication.picture?.name}
                                    picture={currentItem?.sosPublication.picture}
                                    orientation={'portrait_ratio3x4'} width={'780'} height={'1040'}/>
                            </Grid>
                            <Grid item xs={8} sx={{display: 'flex', flexDirection: 'column', justifyContent: 'center'}}>
                                <Typography fontWeight={'bold'}
                                            variant={'subtitle1'}>{currentItem?.sosPublication.title}</Typography>
                                <Typography
                                    variant={'subtitle1'}>{`${t("cart.item_price")}: ${toCommaSeparatedDecimal(currentItem?.price ?? 0)} €`}</Typography>
                            </Grid>
                        </Grid>
                        <Grid item xs={12} sx={{display: 'flex', justifyContent: 'center'}}>
                            <Button variant="contained" sx={{marginTop: 3}} component={'div'} href={cartLink}>
                                {t("cart.go_to_cart")}
                            </Button>
                        </Grid>
                    </CardContent>
                </Card>
            </Snackbar>
        </CCOLink>
    )
}

const cartNotificationSnackbarStyle = {
    position: 'fixed',
    top: {
        xs: INITIAL_OFFSET_CART,
        lg: INITIAL_OFFSET_CART + ADDITIONAL_OFFSET_LARGE_SCREEN + 40
    },
}

export function handleNotificationOpen(setNotificationCardOpen: any) {
    setNotificationCardOpen(true);
    return setTimeout(() => {
        setNotificationCardOpen(false);
    }, 3000);
}

export default C056QueryListCartNotification
